import { format } from 'date-fns';
import { CustomTableCell, CustomTableRow } from '../index';
import {
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableBody,
} from '@mui/material';

export const DashboardTable = (props) => {
  const timeFormat = 'hh:mm:ss a';
  const workSetup = { 1: 'On-site', 2: 'WFH', 3: 'Deployed' };

  return (
    <TableContainer
      sx={{ borderRadius: '5px', boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px' }}
    >
      <Table sx={{ minWidth: '100%' }} aria-label="customized table">
        <TableHead>
          <TableRow>
            <CustomTableCell align="left" value="Date" />
            <CustomTableCell align="left" value="Check In" />
            <CustomTableCell align="left" value="Check Out" />
            <CustomTableCell align="left" value="Total Hours" />
            <CustomTableCell align="left" value="Work Setup" />
            <CustomTableCell align="left" value="Work Description" />
          </TableRow>
        </TableHead>
        <TableBody>
          {props.data
            .map((ts) => (
              <CustomTableRow key={ts.checkin}>
                <CustomTableCell
                  value={format(new Date(ts.checkin), 'dd MMM yyyy')}
                />
                <CustomTableCell
                  value={format(new Date(ts.checkin), timeFormat)}
                />
                <CustomTableCell
                  value={format(new Date(ts.checkout), timeFormat)}
                />
                <CustomTableCell
                  value={Math.floor((ts.roundedtime / 60) * 1000) / 1000}
                />
                <CustomTableCell value={workSetup[ts.worksetup]} />
                <CustomTableCell value={ts.workdesc} />
              </CustomTableRow>
            ))
            .reverse()}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
